import React from "react";
import { Card, Typography } from "antd";
import { CARD_CONFIG } from "../config";

const { Text } = Typography;

interface ErrorCardProps {
  error: string | null;
}

export const ErrorCard: React.FC<ErrorCardProps> = ({ error }) => {
  if (!error) return null;

  return (
    <Card style={CARD_CONFIG.error.style}>
      <Text type="danger">{error}</Text>
    </Card>
  );
};
